import { useEffect ,useState } from 'react';
import { useMsal } from "@azure/msal-react";

export const SignOutButton = () => {
    const { instance } = useMsal();
    const [displayName, setDisplayName] = useState(null);
    useEffect(()=>{
        setDisplayName(sessionStorage.getItem("displayName"));
      }, [])
  
    const handleLogout = (logoutType) => {
        sessionStorage.removeItem("displayName");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("profile");

        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "https://supplier.intel.com/SupplierHub/Logout.aspx",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

    
    return (
        <>
      
               Welcome   {displayName}    &nbsp;
               <a
                                className="navbar-brand headhome"
                                target="_self"
                                //  href="https://ncrmdev.apps1-fm-int.icloud.intel.com/"
                                // href = {this.state.ncrmEnvLink}
                                href="/"
                                id="ahome"
                                data-toggle="tooltip"
                                title="Home"
                            >
                                <i
                                    className="fa fa-home"
                                    aria-hidden="true"
                                    style={{
                                        fontSize: '18px',
                                        lineHeight: '18px',
                                        color: '#e9e9e9',
                                    }}
                                ></i>
                            </a>     
            <button
            className="navbar-brand headhome"
            data-toggle="tooltip"
            onClick={() => handleLogout("redirect")}
            title="Logout"
            style={{ backgroundColor: "transparent", border: "none"}}>
                <span className="intelicon-help-outlined">
                    <i
                        style={{
                        fontSize: "18px",
                        lineHeight: "18px",
                        color: "#e9e9e9",
                        }}
                        className="fas fa-sign-out-alt"
                    ></i>
                </span>
            </button>
        </>
    )
}